export const useZipCodeLookup = ({ customerInfo, setCustomerInfo }) => {
  const handleZipChange = async (e) => {
    const zip = e.target.value;
    setCustomerInfo({ ...customerInfo, zip });

    if (zip.length === 5) {
      try {
        const response = await fetch(`https://api.zippopotam.us/us/${zip}`);
        if (!response.ok) throw new Error("Invalid Zip Code");

        const data = await response.json();
        const place = data.places[0];

        setCustomerInfo((prev) => ({
          ...prev,
          zip,
          city: place["place name"],
          state: place["state abbreviation"],
        }));
      } catch (error) {
        console.error("Zip lookup failed:", error);
        setCustomerInfo((prev) => ({
          ...prev,
          city: "",
          state: "",
        }));
      }
    }
  };

  return { handleZipChange };
};